import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "exam-category-wrapper"
}
const _hoisted_2 = { class: "font-weight-medium category-name" }
const _hoisted_3 = {
  key: 0,
  class: "category-count"
}
const _hoisted_4 = { class: "font-weight-medium category-name" }
const _hoisted_5 = {
  key: 0,
  class: "category-count"
}

import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import Category from '../../models/category'
import Exam from '../../models/exam'
import SlideBar from './SlideBar.vue'
import { getQueryString, getQueryNumber } from '../../../../helpers/route-helper'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ExamCategory'
},
  __name: 'ExamCategory',
  props: {
    category: {},
    padding: { default: 0 },
    isCategoryRoot: { type: Boolean, default: true },
    showEmpty: { type: Boolean, default: false },
    exams: { default: () => [] },
    visible: { type: Boolean, default: false }
  },
  setup(__props: any) {



const props = __props

const router = useRouter()
const route = useRoute()

const arrow = ref('down')
const isVisible = ref(false)

onMounted(() => {
  isVisible.value = props.visible
})

const categoryExams = computed(() => {
  return props.category.getExams(props.exams)
})

const isShowCategory = computed(() => {
  return (Number(props.category.examsCount) != 0 || Number(props.category.score) != 0)
})

const score = computed(() => {
  return Number(props.category.score)
})

const clickPullDown = () => {
  if (arrow.value === 'down') {
    arrow.value = 'up'
  } else {
    arrow.value = 'down'
  }
  isVisible.value = !isVisible.value
}

const clickCategory = () => {
  if (Number(props.category.examsCount) > 0) {
    router.push({ query: { list_id: props.category.id.toString() } })
  }
}

const currentListId = computed(() => {
  return getQueryString(route.query, 'list_id')
})

const currentListIdNumber = computed(() => {
  return getQueryNumber(route.query, 'list_id')
})

const isActive = computed(() => {
  const listId = currentListIdNumber.value
  if (listId === null) return false
  if (props.category.subtreeIds.indexOf(listId) === -1) {
    return false
  } else {
    return true
  }
})

const isCurrentCategory = computed(() => {
  return props.category.id === currentListIdNumber.value
})

const activeClass = computed(() => {
  if (props.category.id === currentListIdNumber.value) {
    return 'actived'
  }
  return ''
})

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_ExamCategory = _resolveComponent("ExamCategory", true)!

  return (Number(__props.category.examsCount) > 0 || __props.showEmpty)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" Root category (parent) "),
        (__props.isCategoryRoot && isShowCategory.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["category-item d-flex align-center gap-2 pa-3 mb-1 rounded-lg", { 'active': isCurrentCategory.value }]),
              onClick: clickCategory
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "currentColor",
                class: "me-2 text-grey"
              }, [
                _createElementVNode("path", { d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" })
              ], -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_2, _toDisplayString(__props.category.name), 1 /* TEXT */),
              _createVNode(_component_v_spacer),
              (Number(__props.category.examsCount) > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.category.examsCount), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (__props.category.hasChildren)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    "aria-hidden": "true",
                    class: _normalizeClass(`v-icon notranslate mdi mdi-chevron-${arrow.value}`),
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (clickPullDown()), ["stop"]))
                  }, null, 2 /* CLASS */))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          : (isShowCategory.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createCommentVNode(" Sub category "),
                _createElementVNode("div", {
                  class: _normalizeClass(["category-item d-flex align-center gap-2 pa-3 mb-1 rounded-lg", { 'active': isCurrentCategory.value, 'ms-4': !__props.category.parentIsRoot }]),
                  onClick: clickCategory
                }, [
                  _cache[3] || (_cache[3] = _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "currentColor",
                    class: "me-2 text-grey"
                  }, [
                    _createElementVNode("path", { d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" })
                  ], -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(__props.category.name), 1 /* TEXT */),
                  _createVNode(_component_v_spacer),
                  (Number(__props.category.examsCount) > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.category.examsCount), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (__props.category.hasChildren)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 1,
                        "aria-hidden": "true",
                        class: _normalizeClass(`v-icon notranslate mdi mdi-chevron-${arrow.value}`),
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (clickPullDown()), ["stop"]))
                      }, null, 2 /* CLASS */))
                    : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */)
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            : _createCommentVNode("v-if", true),
        _createCommentVNode(" Children categories "),
        (isVisible.value)
          ? (_openBlock(), _createBlock(_TransitionGroup, {
              key: 2,
              name: "fade"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.category.children, (subCategory) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "category-row",
                    key: subCategory.name?.toString()
                  }, [
                    _createVNode(_component_ExamCategory, {
                      exams: __props.exams,
                      "show-empty": true,
                      category: subCategory,
                      isCategoryRoot: false,
                      visible: isActive.value
                    }, null, 8 /* PROPS */, ["exams", "category", "visible"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}
}

})